import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=2fe2a3ff&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=2fe2a3ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe2a3ff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fe2a3ff')) {
      api.createRecord('2fe2a3ff', component.options)
    } else {
      api.reload('2fe2a3ff', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=2fe2a3ff&scoped=true&", function () {
      api.rerender('2fe2a3ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2FdOju7M4rfC8/JS/teamMember.vue"
export default component.exports